import * as yup from 'yup';

export const personCreateSchema = yup.object().shape({
    
    firstName: yup.string().required('First name is required'),
    lastName: yup.string().required('Last name is required'),
    genderId: yup.number().required('Gender is required').typeError('Gender is required'),
    raceId: yup.number().required('Race is required').typeError('Race is required'),
    occupationLevelTypeId: yup.number() .typeError("Occupational Level is required").required("Occupational Level is required"),
    employeeTypeId: yup.number().typeError("Employment Type is required").required("Employment Type is required"),
    dateOfBirth: yup.date().nullable().default(null).transform((curr, orig) => orig === '' ? null : curr),
    identificationNumber: yup.string().when('employeeCode', {
        is: (employeeCode: string) => !employeeCode || employeeCode.length === 0,
        then: yup.string().required("ID Number or Employee Code is required"),
        otherwise: yup.string().nullable()
    }),
    employeeCode: yup.string().when('identificationNumber', {
        is: (identificationNumber: string) => !identificationNumber || identificationNumber.length === 0,
        then: yup.string().required("ID Number or Employee Code is required"),
        otherwise: yup.string().nullable()
    })
}, [[ 'employeeCode', 'identificationNumber' ]]
);

export const personEditSchema = yup.object().shape({
    
    firstName: yup.string().required('First name is required'),
    lastName: yup.string().required('Last name is required'),
    genderId: yup.number().required('Gender is required').typeError('Gender is required'),
    raceId: yup.number().required('Race is required').typeError('Race is required'),
    dateOfBirth: yup.date().nullable().default(null).transform((curr, orig) => orig === '' ? null : curr),
    identificationNumber: yup.string().when('employeeCode', {
        is: (employeeCode: string) => !employeeCode || employeeCode.length === 0,
        then: yup.string().required("ID Number or Employee Code is required"),
        otherwise: yup.string().nullable()
    }),
    employeeCode: yup.string().when('identificationNumber', {
        is: (identificationNumber: string) => !identificationNumber || identificationNumber.length === 0,
        then: yup.string().required("ID Number or Employee Code is required"),
        otherwise: yup.string().nullable()
    })
}, [[ 'employeeCode', 'identificationNumber' ]]
);